// Shell/PageHeader (real Figma instance): eyebrow .type-labelSm in
// --accent-on-light, title .type-h1, description .type-body capped at 620px.
//
// THE ONLY PageHeader. Wave 0's `frontend/src/shell/PageHeader.tsx` was a
// second, thinner copy of the same Figma instance with no importers left; it
// was deleted in Wave 3. Do not reintroduce a shell-local one.

import "./ui.css";
import type { ReactNode } from "react";

export type PageHeaderProps = {
  title: string;
  /** Small rust label above the title, e.g. "ANALYTICS". */
  eyebrow?: string;
  description?: string;
  actions?: ReactNode;
};

export function PageHeader({
  title,
  eyebrow,
  description,
  actions,
}: PageHeaderProps) {
  return (
    <header className="maisight-ui-page-header">
      <div>
        {eyebrow ? (
          <p className="maisight-ui-page-header-eyebrow type-labelSm">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="maisight-ui-page-header-title type-h1">{title}</h1>
        {description ? (
          <p className="maisight-ui-page-header-description type-body">
            {description}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="maisight-ui-page-header-actions">{actions}</div>
      ) : null}
    </header>
  );
}
